export default "__VITE_ASSET__OSXKk$f0__"